module.exports = __webpack_public_path__ + "img/1.51d09fa8.png";